import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { UseFindTheLetter } from '../providers/FindTheLetterProvider/types';
import { FindTheLetterContext } from '../providers/FindTheLetterProvider';

export const useFindTheLetter = (): UseFindTheLetter => {
  const [state, dispatch] = useContextWithErrorHandler(
    FindTheLetterContext,
    'FindTheLetterProvider'
  );
  return [state, dispatch];
};
